// Shared constants and small components for the AEP report family.
export const SECTIONS = [
  { k: "capa",          label: "Capa e identificação técnica" },
  { k: "sumario",       label: "Sumário executivo" },
  { k: "dashboard",     label: "Dashboard executivo" },
  { k: "controle_doc",  label: "Controle documental" },
  { k: "resumo",        label: "Resumo executivo" },
  { k: "prioridades",   label: "Prioridades recomendadas" },
  { k: "rastreabilidade", label: "Rastreabilidade técnica" },
  { k: "heatmap",       label: "Mapa de calor" },
  { k: "timeline",      label: "Timeline 30/60/90/180" },
  { k: "checklist",     label: "Checklist auditoria MTE" },
  { k: "lgpd",          label: "Termo LGPD" },
  { k: "intro",         label: "Introdução técnica (16 itens)" },
  { k: "base",          label: "Base importada" },
  { k: "consolidacao",  label: "Consolidação por dimensão" },
  { k: "matriz",        label: "Matriz AIHA P×S" },
  { k: "matriz_consolidada", label: "Matriz Consolidada por CNPJ (Geral · GHE · Setor · Individual)" },
  { k: "plano",         label: "Plano de ação consolidado" },
  { k: "recomendacoes_ia", label: "Recomendações Prioritárias" },
  { k: "plano_anual",   label: "Plano Anual SST (anexo)" },
  { k: "absenteismo",   label: "Absenteísmo NR-01 (anexo)" },
  { k: "conclusao",     label: "Conclusão técnica" },
  { k: "assinaturas",   label: "Assinaturas e referências" },
];

export const ORIENT_CLASS = {
  retrato: "max-w-[820px]",
  paisagem: "max-w-[1280px]",
};
export const MARGIN_CLASS = {
  estreita: "px-6 py-4",
  normal: "px-10 py-8",
  larga: "px-16 py-12",
};
export const FONT_CLASS = {
  pequena: "text-[12px]",
  normal: "text-[14px]",
  grande: "text-[16px]",
};
export const MARGIN_MM = { estreita: "10mm", normal: "18mm", larga: "25mm" };

export function RiskTag({ level, label }) {
  const cls = level === 0 ? "risk-0" : `risk-${level}`;
  return <span className={`${cls} border px-2 py-1 text-xs font-bold uppercase tracking-wider`}>{label}</span>;
}

/**
 * Stylised Sollute leaf — inline SVG so we can scale/colour/blur it
 * freely throughout the cover. The silhouette mirrors the leaf in the
 * Sollute Ocupacional logomark (single broad leaf with central vein).
 */
export function SolluteLeaf({ className = "", color = "#8BC53F", opacity = 1, rotate = 0, "aria-hidden": ariaHidden = true }) {
  return (
    <svg viewBox="0 0 200 240" xmlns="http://www.w3.org/2000/svg"
         aria-hidden={ariaHidden}
         className={className}
         style={{ transform: `rotate(${rotate}deg)`, opacity }}>
      {/* Leaf body */}
      <path
        d="M100 12 C 55 38, 24 92, 24 152 C 24 198, 56 226, 100 228 C 144 226, 176 198, 176 152 C 176 92, 145 38, 100 12 Z"
        fill={color} />
      {/* Central vein (slightly darker) */}
      <path
        d="M100 18 L 100 224"
        stroke="rgba(0,0,0,0.15)" strokeWidth="3" strokeLinecap="round" />
      {/* Side veins */}
      <path
        d="M100 70 Q 60 92, 36 130 M100 70 Q 140 92, 164 130
           M100 120 Q 60 142, 38 180 M100 120 Q 140 142, 162 180
           M100 170 Q 70 188, 50 208 M100 170 Q 130 188, 150 208"
        stroke="rgba(0,0,0,0.10)" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}
